import { FC, useRef, useState } from "react";
import { Box, Button, Paper, TextField, Typography, InputAdornment } from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";
import PersonIcon from "@mui/icons-material/Person";
import { useUser } from "../hooks/useUser";
import { useNavigate } from "react-router-dom";
import LoadingAnimation from "../components/_common/Loading";
import AuthController from "../Api/authController";
import { useToast } from "../hooks/useToast";

interface InvoiceLoginPanelProps {}

const InvoiceLoginPanel: FC<InvoiceLoginPanelProps> = () => {
    const [name, setName] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const user = useUser();
    const navigate = useNavigate();
    const toast = useRef(useToast()).current
    

    const handleClick = async () => {
        setLoading(true)
        const res = await AuthController.login({
            username: 'invoice',
            password: password
        })
        if (!res.ok || !res.token) {
            toast.error(res.message);
            setLoading(false);
            return;
        }
        if (res.user) user.setSession(res.user);
        localStorage.setItem("invoiceName", name);
        navigate("/proformy");
    }

    if (loading) return <LoadingAnimation />

    return (
        <Box
            minHeight="100vh"
            display="flex"
            alignItems="center"
            justifyContent="center"
            sx={{ background: "linear-gradient(120deg, #f7fafc 60%, #e0e7ef 100%)" }}
        >
            <Paper elevation={6} sx={{ p: 4, borderRadius: 3, minWidth: 350 }}>
                <Typography variant="h5" fontWeight={700} mb={3} textAlign="center">
                    Logowanie do panelu faktur
                </Typography>
                <form onSubmit={(event) => { event.preventDefault(); handleClick(); }}>
                    <TextField
                        label="Imię i nazwisko (będą widoczne na fakturze)"
                        variant="outlined"
                        fullWidth
                        required
                        margin="normal"
                        value={name}
                        onChange={e => setName(e.target.value)}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <PersonIcon color="primary" />
                                </InputAdornment>
                            ),
                        }}
                    />
                    <TextField
                        label="Hasło"
                        type="password"
                        variant="outlined"
                        fullWidth
                        required
                        margin="normal"
                        value={password}
                        onChange={e => setPassword(e.target.value)}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <LockIcon color="primary" />
                                </InputAdornment>
                            ),
                        }}
                    />
                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        fullWidth
                        sx={{ mt: 2, fontWeight: 600, letterSpacing: 1 }}
                    >
                        Zaloguj się
                    </Button>
                </form>
            </Paper>
        </Box>
    );
};

export default InvoiceLoginPanel;
